import { render, staticRenderFns } from "./StrokeWidthSlider.vue?vue&type=template&id=fa5b9c4a&"
import script from "./StrokeWidthSlider.vue?vue&type=script&lang=js&"
export * from "./StrokeWidthSlider.vue?vue&type=script&lang=js&"
import style0 from "./StrokeWidthSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports